// extracted by mini-css-extract-plugin
export default {"button":"Button_button__fGuZK","backbutton":"Button_backbutton__8Wn5B","center":"Button_center__e2Ziu"};